//
// Parts List
//
// ---------------------------------------------------------------------------

'use strict';

import FormCollection from './form-collection';

const config = {
    formSelector: '.js-part-block',
    listSelector: '.o-parts-list',
    prototypeRegex: /__parts__/g,
    partNumberSelector: '.js-part-number',
    descriptionSelector: '.js-part-description',
    partTypeSelector: '.js-part-type',
    defaultSize: 3
};

$(window).load(function(){

    const $partsListCollectionContainer = $(config.listSelector);
    const initialSize = $partsListCollectionContainer.data('initial-size') ? $partsListCollectionContainer.data('initial-size') : config.defaultSize;

    new FormCollection({
        $collectionContainer : $partsListCollectionContainer,
        formSelector : config.formSelector,
        prototypeRegex : config.prototypeRegex,
        initialSize: initialSize,
        postAdd : function ($formBlock) {
            // Handle part numbers when we leave the part number field. Only do this for configured types which are
            // defined by those who have a product_lookup_url defined. Currently only RS parts, but soon to include allied also.
            $formBlock.find(config.partNumberSelector).on('blur', function () {
                const stockNumber = this.value;
                const productLookupUrl = $formBlock.find(config.partTypeSelector).find(":selected").data('product_lookup_url');

                // No lookup configured, bail.
                if (!productLookupUrl) {
                    return;
                }

                if (stockNumber) {
                    const url = productLookupUrl + stockNumber;

                    $.ajax({
                        url: url,
                        dataType: 'json',
                        success: function (response) {
                            if (response.name) {
                                $formBlock.find(config.descriptionSelector).val(response.name);
                            }
                        }
                    });
                }
            })
        }
    });

});



// WEBPACK FOOTER //
// ./src/js/components/parts-list-form.js